import React from 'react';
import PropTypes from 'prop-types';
import { Button, Badge } from '@dev-go4ellis/go4-design-system';
import './Coverage.scss';

const TRUSTS = [
  { icon: '🛡️', title: 'Insured', body: 'General liability coverage on every shift.' },
  { icon: '📋', title: 'Credentialed', body: 'Every trainer is background-checked and license-verified.' },
  { icon: '🔒', title: 'HIPAA-compliant', body: 'Documentation stored securely in your Go4 account.' },
];

const Coverage = ({ onBackToEstimator }) => (
  <section className="pl-coverage">
    <div className="pl-coverage__inner">
      <div className="pl-coverage__badge">
        <Badge variant="soft" color="info" size="sm">COVERAGE &amp; COMPLIANCE</Badge>
      </div>

      <h2 className="pl-coverage__title">
        The fee is the risk work you'd otherwise do yourself
      </h2>
      <p className="pl-coverage__subtitle">
        Every trainer who accepts your job has been credential-checked, insured
        and paid through Go4. Documentation lands in your account, not in
        someone's glovebox.
      </p>

      <div className="pl-coverage__grid">
        {TRUSTS.map((t) => (
          <div key={t.title} className="pl-coverage__item">
            <div className="pl-coverage__icon">{t.icon}</div>
            <div className="pl-coverage__item-title">{t.title}</div>
            <div className="pl-coverage__item-body">{t.body}</div>
          </div>
        ))}
      </div>

      <div className="pl-coverage__back-wrap">
        <Button variant="secondary" size="md" onClick={onBackToEstimator}>
          Back to the estimator ↑
        </Button>
      </div>
    </div>
  </section>
);

Coverage.propTypes = {
  onBackToEstimator: PropTypes.func.isRequired,
};

export default Coverage;
